import React from 'react'
import mainContext from '../../contexts/mainContext';
import { getReviewListing } from '../../Controllers/userManagment/common';
import Pagination from '@mui/material/Pagination';
import { __constants, __snackBarText, __snackBarSeverity } from '../../constants';
import ReviewCard from './ReviewCard';
import SearhcBar from '../../common_components/SearchBar';
import Sorting from '../../common_components/Sorting';
import { styled } from '@mui/material';
import moment from 'moment';

const ReviewListing = () => {
    const { setSnackBar, setProfileNavTitle, filterState, setPageload } = React.useContext(mainContext);
    const [review, setReviews] = React.useState([]);
    const [totalCount, setTotalCount] = React.useState(1);

    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    const getReviews = async (page) => {
        let param = null;
        param = { page: page, ...filterState };
        setPageload(true)
        const res = await getReviewListing(param);
        setPageload(false)
        if (res && res.status === 500) {
            return callSnackBar(__snackBarText.internalServerError, "error")
        }
        if (res.data.status !== 200) {
            return callSnackBar(res.data.errors[0].message, "error");
        }
    
        setReviews(res.data.data.reviews);
        setTotalCount(res.data.data.total);
    }

    const handlePaginationClick = (e, page) => {
        getReviews(page)
    }

    React.useEffect(() => {
        getReviews(1);
        setProfileNavTitle("REVIEWS");
        // eslint-disable-next-line
    }, [filterState])


    return (
        <>

            <SearhcBar callFunction={() => getReviews(1, true)} isFilter={true} typeList={["date-range", "rating", "city"]} />

            <div className="component_body scrollbar">
                <List className="list_header">
                    <div style={{ display: 'flex', alignItems: "center" }}>Status</div>
                    <div style={{ display: 'flex', alignItems: "center" }}>Rating <Sorting callFunction={getReviews} type={"sByRating"} />
                    </div>
                    <div style={{ display: 'flex', alignItems: "center" }}>Written by / Role <Sorting callFunction={getReviews} type={"sByName"} />
                    </div>
                    <div style={{ display: 'flex', alignItems: "center" }}>Written for / Role</div>
                    <div style={{ display: 'flex', alignItems: "center" }}>City</div>
                    <div style={{ display: 'flex', alignItems: "center" }}>Posted on  <Sorting callFunction={getReviews} type={"sByPosted"} />
                    </div>
                    <div style={{ textAlign: "right" }}>Review</div>
                </List>

                <div>
                    {
                        review.map((e, index) => {
                            return (
                                <ReviewCard
                                    key={e._id}
                                    id={e._id}
                                    rating={e.rating}
                                    status={e.status}
                                    revieweeInfo={e.revieweeInfo}
                                    reviewerInfo={e.reviewerInfo}
                                    city={e.city}
                                    reviewerName={e.name}
                                    comment={e.comment}
                                    postOn={moment(e.createdAt).format("ddd, DD/MM/YYYY")}
                                    callBack={(data) => { let list = review; list[index].status = data.status; setReviews(list) }}
                                />
                            )
                        })
                    }
                </div>
                {review.length === 0 && <div className='no-record'><span>No Record Found</span></div>}
            </div>

            <Pagination count={Math.ceil(totalCount / __constants.listingLimit)} color="primary" shape="rounded" onChange={(e, page) => { handlePaginationClick(e, page) }} />
            <br />
        </>
    )
}

export default ReviewListing;
const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  margin-top: 1rem;
  display: grid;
  column-gap: 0.2rem;
  grid-template-columns: minmax(0,1fr) minmax(0,1fr) minmax(0,3.2fr) minmax(0,3.2fr) minmax(0,1.5fr) minmax(0,1.5fr) minmax(0,0.8fr);
  align-items: center;
  font-size:14px;
`;